import { toExcelFormat } from '../../helpers/format-position';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActionService } from '../../core/services/action.service';
import { TaskRequestSidenavService } from '../../core/services/task-request-sidenav.service';
import centimetersToMeters from '../../helpers/centimeters-to-meters';

@Component({
  selector: 'app-pallet-inventory-sidenav',
  templateUrl: './pallet-inventory-sidenav.component.html',
  styleUrls: ['./pallet-inventory-sidenav.component.scss']
})
export class PalletInventorySidenavComponent implements OnInit, OnChanges {
  @Input() drawer;
  @Input() data;
  usersHighlighted = [];
  selectOperatorError = false;
  tableData = [];
  displayedColumns = ['tagRfid', 'sku', 'level', 'position', 'quantity'];
  columnDefinition = [
    { key: "tagRfid", text: "Tag Rfid", showTooltip: true },
    { key: "sku", text: "Código do Item" },
    { key: "position", text: "Posição", showTooltip: true },
    { key: 'level', text: "Nível" },
    { key: "quantity", text: "Quantidade", alignRight: true },
  ];

  constructor(
    private sidenavService: TaskRequestSidenavService,
    private actionService: ActionService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.formatArrayToTable();
  }

  formatArrayToTable() {
    const position = this.data.position.alias?.length ? this.data.position.alias : '--- (coordenada: ' + this.getCoords(this.data.crate.x, this.data.crate.y) + ')';
    this.tableData = this.data.crate.skuGroups.map(item => {
      return {
        quantity: item.quantity * item.packSize,
        sku: item.sku,
        tagRfid: this.data.crate.tagRfid,
        level: this.data.crate.level,
        position: position
      }
    });
  }

  setUsers(users) {
    this.usersHighlighted = users;
  }

  close() {
    this.tableData = [];
    this.drawer.close();
    this.sidenavService.closeSidenav({ keepSelection: true });
  }

  async submit() {
    this.setOperatorLengthError();
    await this.inventory();
    this.drawer.close();
    this.sidenavService.closeSidenav(true);
  }

  async inventory() {
    const selectedPalletsTagsRfid = [];
    selectedPalletsTagsRfid.push(this.data.crate.tagRfid);
    const data = {
      type: "INVENTORY_BY_TAG_RFID",
      userIds: this.usersHighlighted,
      taskData: {
        deepSearch: false,
        tagRfid: selectedPalletsTagsRfid
      }
    };
    await this.actionService.inventoryByTagRfid(data);
  }

  setOperatorLengthError() {
    this.selectOperatorError = !this.usersHighlighted.length;
  }

  getHeight(z) {
    return centimetersToMeters(z);
  }

  getCoords(x, y) {
    return toExcelFormat(x, y);
  }
}
